"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralInvitationStatusEnum = void 0;
var ReferralInvitationStatusEnum;
(function (ReferralInvitationStatusEnum) {
    ReferralInvitationStatusEnum["WaitingForPayment"] = "waitingForPayment";
    ReferralInvitationStatusEnum["ProtectionPeriod"] = "protectionPeriod";
    ReferralInvitationStatusEnum["Successful"] = "successful";
    ReferralInvitationStatusEnum["Canceled"] = "canceled";
})(ReferralInvitationStatusEnum = exports.ReferralInvitationStatusEnum || (exports.ReferralInvitationStatusEnum = {}));
//# sourceMappingURL=referral-invitation-status-enum.js.map